import { IconComponent, OpenInNew, SmallIcon } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"
import classNames from "classnames"
import { memo, MouseEvent, useState } from "react"

type FlyoutMenuActionTabProps = {
    title: string
    icon: IconComponent
    shouldShowExitIcon?: boolean
    onClick?: (e: MouseEvent) => void
}

const FlyoutMenuActionTab = memo(
    ({ title, icon, shouldShowExitIcon, onClick }: FlyoutMenuActionTabProps) => {
        const { t } = useTranslation()
        const [isHovering, setIsHovering] = useState(false)

        return (
            <div
                className={classNames(
                    "h-8 rounded-lg px-4 my-1 py-1.5 flex items-center gap-3 cursor-pointer select-none",
                    {
                        "text-gray-0": !isHovering,
                        "text-gray-900 bg-blue-500": isHovering,
                    }
                )}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={onClick}
            >
                <SmallIcon Icon={icon} />
                <small>{t(title)}</small>
                <div className="flex flex-grow mr-1" />
                {isHovering && shouldShowExitIcon && (
                    <SmallIcon Icon={OpenInNew} className="text-black-500" />
                )}
            </div>
        )
    }
)
FlyoutMenuActionTab.displayName = "FlyoutMenuActionTab"
export { FlyoutMenuActionTab }
